import { lazy } from 'react'

export const ProductPublicKeyModalAsync = lazy(() =>
    import('./ProductPublicKeyModal').then((module) => ({
        default: module.ProductPublicKeyModal,
    }))
)
